import { GestureController } from '@ionic/angular';
import { AppSingletonUtil } from './../../../../../../Util/AppSingletonUtil';
import { SocialLinkSettingPanelController } from './SocialLinkSettingPanelController';
import { UnlinkSocialPopupComponent } from './UnlinkSocialPopup/UnlinkSocialPopupComponent';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Fade, SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';

import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { MatDialog } from '@angular/material/dialog';
import { AppSetting } from 'src/app/AppSetting';
import { environment } from '../../../../../../../environments/environment';

@Component({
	selector: 'app-mypage-component',
	templateUrl: './SocialLinkSettingPanelComponent.html',
	styleUrls: ['./SocialLinkSettingPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class SocialLinkSettingPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: SocialLinkSettingPanelController;

	// ジェスチャー対象のElement参照
	@ViewChild('gesturePage', { read: ElementRef, static: false }) gesturePage: ElementRef;

	// ライン連携のステータス
	public linkStatus: boolean;
	// ライン連携の状態文言
	public linkStr = '';

	// ラインボタンのベースタイプアセットPath
	public lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/1x/44dp/btn_login_base.png';

	public loginUrl ='';

	public stateString = '';

	public nonceString = '';
	public lineFriendUrl = environment.LINE_FRIEND_URL;

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public renderer: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		this.createController(SocialLinkSettingPanelController);
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// Lineとの連携状態を取得して、設定する
		await this.getSocialLinkStatus();

		// スライドイン表示は自分でやる
		await this.slideIn();

		// ジェスチャーを与える対象を設定する
		this.setGestureTargetElementRef(this.gesturePage);

	}

	/**
	 * Lineの認可リクエストURL設定
	 */
	public async setLoginUrl() {

		this.stateString = await this.combineCtrl.getState();
		this.nonceString = await this.combineCtrl.getNonce();

		const conf = await this.combineCtrl.getConfigForClient();

		await this.combineCtrl.setStateNonce({
			stateString: this.stateString,
			nonceString: this.nonceString,
		});

		this.loginUrl = conf.login_url + '?';
		this.loginUrl = this.loginUrl + `response_type=${conf.response_type}` + '&';
		this.loginUrl = this.loginUrl + `client_id=${conf.chanel_id}` + '&';
		this.loginUrl = this.loginUrl + `redirect_uri=${encodeURIComponent(conf.redirect_uri)}` + '&';
		this.loginUrl = this.loginUrl + `disable_auto_login=${conf.disable_auto_login}` + '&';
		this.loginUrl = this.loginUrl + `state=${encodeURIComponent(this.stateString)}` + '&';
		this.loginUrl = this.loginUrl + `scope=${conf.scope}` + '&';
		this.loginUrl = this.loginUrl + `nonce=${this.nonceString}` + '&';
		this.loginUrl = this.loginUrl + `bot_prompt=${conf.bot_prompt}`;
	}

	/**
	 * Lineでログイン
	 */
	public async onClickLoginLine() {
		await this.setLoginUrl();
		if (!await this.combineCtrl.recordAuth(this.loginUrl, this.stateString, this.nonceString)) {
			this.showAlertDialog('エラー', 'ログインできません。');
		} else {
			this.showSpinnerMainView(this);
			window.location.href = this.loginUrl;
		}
	}

	/**
	 * getSocialLinkStatus
	 * Lineとの連携状態を取得して、設定する
	 * @returns Lineとの連携状態（true: 連携/ false: 未連携）
	 */
	public async getSocialLinkStatus() {

		// Lineとの連携状態を取得する
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getLineLinkStatus.bind(this),
			{ view: this }
		);
		if (!ret) {
			// できなければダイアログ閉じないでそのまま
			return;
		}
		this.linkStatus = ret.result;

		// 連携状態から連携文言を設定する
		this.dispatchBtnFromLineStatus();

	}

	/**
	 * onClickUnlinkLine
	 * LINE連携解除ボタン
	 */
	public async onClickUnlinkLine() {

		this.log('onClickUnlinkLine');

		// 連携解除ポップアップを表示する
		await this.showDialogWindow(
			UnlinkSocialPopupComponent,
			{
				close: this.confirmReceive.bind(this),
				cancel: this.dismissDialogWindow.bind(this)
			}
		);

	}

	//////////////////////////////////////
	// 別画面からの処理
	/**
	 * confirmReceive
	 * ライン連携を解除する処理
	 * ポップアップ画面から呼び出される
	 */
	public async confirmReceive() {

		// LINE連携を解除する
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.unlinkSocialLink.bind(this),
			{
				view: this
			}
		);
		if (!ret) {
			// できなければダイアログ閉じないでそのまま
			return;
		}

		// Lineとの連携状態を取得して、設定する
		await this.getSocialLinkStatus();
		// ポップアップを閉じる
		await this.dismissDialogWindow();

	}


	/**
	 * dispatchBtnFromLineStatus
	 * ラインステータスからボタンの表示状態をディスパッチして、文字列を取得する
	 */
	public dispatchBtnFromLineStatus() {

		// 連携済みの場合
		if (this.linkStatus) {
			this.linkStr = '連携済みです。';
			return;
		}

		// 連携されていない場合
		this.linkStr =  '未連携';

	}


	//////////////////////////////////////
	// ボタンの画像切替処理
	/**
	 * onMousedownLineLogin
	 * LINEログインボタンの押下時の画像変更
	 */
	 public onMousedownLineLogin() {
		this.log('on press');
		this.lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/1x/44dp/btn_login_press.png';
	}
	/**
	 * onMouseoverLineLogin
	 * LINEログインボタンのマウスオーバー時の画像変更
	 */
	public onMouseoverLineLogin() {
		this.log('on hover');
		this.lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/1x/44dp/btn_login_hover.png';
	}
	/**
	 * onMouseoutLineLogin
	 * LINEログインボタンのマウスアウト時の画像変更
	 */
	public onMouseoutLineLogin() {
		this.log('on blur');
		this.lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/1x/44dp/btn_login_base.png';
	}

}
